import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileDown, Mail, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const detail = (err, fallback) => {
  const d = err?.response?.data?.detail;
  return typeof d === 'string' ? d : fallback;
};

export default function OfferActions({ order, price }) {
  const [busy, setBusy] = useState('');
  const [email, setEmail] = useState('');
  const [hint, setHint] = useState('');

  const ready = (order.kind === 'package' || order.kind === 'campaign') && !!order.selectionId && price.totalNetto > 0;
  if (!ready) return null;

  const createOffer = async () => {
    const { data } = await axios.post(`${API}/offers`, {
      kind: order.kind, selectionId: order.selectionId, months: Number(order.months) || 1,
      founder: !!order.founder, spotProduction: order.spotProduction, exclusivity: !!order.exclusivity,
      timeWindow: !!order.timeWindow, sponsoring: !!order.sponsoring,
      company: order.company || null, contactPerson: order.contactPerson || null, email: order.email || null,
    });
    return data;
  };

  const downloadPdf = async () => {
    setBusy('pdf'); setHint('');
    try {
      const data = await createOffer();
      window.open(`${process.env.REACT_APP_BACKEND_URL}${data.pdfUrl}`, '_blank', 'noopener');
      setHint('Angebot erstellt – der Download läuft in einem neuen Tab.');
    } catch (err) { toast.error(detail(err, 'Angebot konnte nicht erstellt werden.')); }
    finally { setBusy(''); }
  };

  const sendMail = async (e) => {
    e.preventDefault();
    setBusy('mail'); setHint('');
    try {
      const data = await createOffer();
      const res = await axios.post(`${API}/offers/${data.id}/email`, { email: email.trim() });
      setHint(res.data.message);
      if (res.data.sent) { toast.success('Angebot per E-Mail verschickt.'); setEmail(''); }
      else toast.message(res.data.message);
    } catch (err) { toast.error(detail(err, 'E-Mail konnte nicht verschickt werden.')); }
    finally { setBusy(''); }
  };

  return (
    <div className="mt-6 border-t border-[#282C37] pt-5" data-testid="offer-actions">
      <p className="eyebrow">Unverbindliches Angebot</p>
      <p className="t-muted mt-2 !text-xs">Ohne Unterschrift, 30 Tage gültig – zum Mitnehmen oder Weiterleiten.</p>
      <button type="button" onClick={downloadPdf} disabled={!!busy} data-testid="offer-pdf-button" className="btn-ghost mt-3 w-full !py-2.5 !text-xs disabled:opacity-60">
        {busy === 'pdf' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileDown className="h-3.5 w-3.5" />} Angebot als PDF
      </button>
      <form onSubmit={sendMail} className="mt-2 flex gap-2">
        <input
          type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ihre@firma.de"
          data-testid="offer-email-input" className="input !py-2.5 !text-xs" aria-label="E-Mail für das Angebot"
        />
        <button type="submit" disabled={!!busy || !email.trim()} data-testid="offer-email-button"
          className="btn-primary shrink-0 !px-4 !py-2.5 !text-xs disabled:opacity-60">
          {busy === 'mail' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Mail className="h-3.5 w-3.5" />} Senden
        </button>
      </form>
      {hint && <p className="mt-2 text-xs font-medium text-[#FF6B00]" data-testid="offer-hint">{hint}</p>}
    </div>
  );
}
